import React, { useState, useEffect } from "react";
import { API, graphqlOperation } from "aws-amplify";
import {
  accountByActiveByNameDropDown,
  getLocationProduct,
  productByAccountByActiveByNameDropDown,
} from "../../../graphql/account/account-queries";

import { inventoryItemByLocationByStatus } from "../../../graphql/queries";
import { updateLocation } from "../../../graphql/mutations";
import { updateInventoryItemMini } from "../../../graphql/inventory/custom-mutations";
import {
  Backdrop,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  FormLabel,
  Grid,
  InputAdornment,
  MenuItem,
  TextField,
} from "@material-ui/core";

import { Confirm, useNotify } from "react-admin";
import { ClearIcon, RemoveIcon } from "../../../components/common/iconography";

import { logError } from "../../../utils/appUtils";
import {
  InventoryStatus,
  LocationLoadType,
  LocationType,
  UnitOptions,
} from "../../../utils/constants";
import {
  getLocationViewName,
  getLocationFullName,
  createAggregateInventory,
  deAggregateInventory,
  isBulkLocation,
  getLocationPrefix,
  isLocationEditDisabled,
} from "../../../utils/locationUtils";
import { handleNumberFieldKeyDown, trimDecimal } from "../../../utils/utils";

const getBulkUnitOptions = (allowEmpty = false) => {
  const options = UnitOptions.map((itm) => (
    <MenuItem key={itm.id} value={itm.id}>
      {itm.name}
    </MenuItem>
  ));
  if (allowEmpty) {
    options.unshift(
      <MenuItem key="" value="">
        <span></span>
      </MenuItem>,
    );
  }

  return options;
};

const isLoadTypeDisabled = (selectedLocation, loadType) => {
  // check if the location EDIT should be disabled or not
  if (isLocationEditDisabled(selectedLocation)) return true;

  // correctly set the locationLoads
  let locationLoads = null;
  if (
    selectedLocation.locationLoad &&
    Object.keys(selectedLocation.locationLoad).length > 0
  ) {
    locationLoads = selectedLocation?.locationLoad;
  } else {
    locationLoads = selectedLocation?.aisle?.locationLoad;
  }

  // this should never happen -- (we have examples on prod tho) -- but just in case
  if (!locationLoads) return false;

  // if the location is a container, then it should be disabled
  if (locationLoads?.container?.selected) return true;

  // if the location is a container, then it should be disabled
  if (loadType === LocationLoadType.OTHER) {
    return !locationLoads[LocationLoadType.OTHER].selected;
  }

  const locationType = selectedLocation.type;
  if (
    loadType === LocationLoadType.DRY_BULK ||
    loadType === LocationLoadType.LIQUID_BULK
  ) {
    return (
      locationType !== LocationType.BULK &&
      locationType !== LocationType.BULK_MOBILE
    );
  }

  return locationLoads[LocationLoadType.OTHER].selected;
};

const areLocationLoadsEqual = (initLocation, updatedLocation) => {
  const initLoad = initLocation.locationLoad;
  const updatedLoad = updatedLocation.locationLoad;
  const initKeys = Object.keys(initLoad);
  const updatedKeys = Object.keys(updatedLoad);

  if (initKeys.length !== updatedKeys.length) return false;

  for (let key of initKeys) {
    if (
      !updatedLoad.hasOwnProperty(key) ||
      initLoad[key].selected !== updatedLoad[key].selected
    ) {
      return false;
    }
  }

  return true;
};

const mergeLocationLoads = (aisle, selectedLocation) => {
  // Reset all aisle.locationLoad properties to false initially
  Object.keys(aisle.locationLoad).forEach((key) => {
    aisle.locationLoad[key].selected = false;
  });

  // update aisle in place
  aisle.locations.items.forEach((location) => {
    if (location.id === selectedLocation.id) {
      location.locationLoad = selectedLocation.locationLoad;
    }

    // Check and update the aisle.locationLoad
    Object.keys(aisle.locationLoad).forEach((key) => {
      if (location.locationLoad[key] && location.locationLoad[key].selected) {
        aisle.locationLoad[key].selected = true;
      }
    });
  });
};

const getAccounts = async (setAccounts) => {
  const response = await API.graphql(
    graphqlOperation(accountByActiveByNameDropDown, {
      reloadYardId: window.appUser?.reloadYardId,
      activeBusinessName: { beginsWith: { active: "true" } },
    }),
  );
  const accounts = response.data.accountByActiveByName.items;
  setAccounts(accounts);
  return accounts;
};
const getProducts = async (
  selectedLocation,
  accountId,
  setLoading,
  setProducts,
  notify,
) => {
  try {
    setLoading(true);
    debugger;
    const input = {
      accountId: accountId,
      activeName: { beginsWith: { active: "true" } },
      limit: 1000,
    };
    const resp = await API.graphql(
      graphqlOperation(productByAccountByActiveByNameDropDown, input),
    );
    let productResponse = resp.data.productByAccountByActiveByName.items;
    if (selectedLocation.zone.reloadYardCommodityId) {
      productResponse = productResponse.filter(
        (product) =>
          product.reloadYardCommodityId ===
          selectedLocation.zone.reloadYardCommodityId,
      );
    }
    setProducts(productResponse);
  } catch (error) {
    logError("Locations:StructuredLocationDialog:getProducts", error, notify);
  } finally {
    setLoading(false);
  }
};

export const StructuredLocationDialog = ({
  location,
  aisle,
  classes,
  open,
  handleClose,
  refresh,
  updateSelectedAisle,
}) => {
  const [loading, setLoading] = useState(false);
  // const [locationStorageType, setLocationStorageType] = useState(location?.storageType ? location.storageType : "storage");
  const [selectedLocation, setSelectedLocation] = useState({
    ...location,
    name: getLocationViewName(location),
  });
  const capacityList = [10, 20, 25, 30, 40, 50, 60, 70, 75, 80, 90, 100];
  const [lengthError, setLengthError] = useState(false);
  const [bulkCapacityError, setBulkCapacityError] = useState(false);
  const [accountProductError, setAccountProductError] = useState(false);
  const [accounts, setAccounts] = useState([]);
  const [selectedAccountId, setSelectedAccountId] = useState(
    location.accountId || "",
  );
  const [products, setProducts] = useState([]);
  const [confirmLocationOpen, setConfirmLocationOpen] = useState(false);
  const [confirmLocationTitle, setConfirmLocationTitle] = useState("");
  const [confirmLocationContent, setConfirmLocationContent] = useState("");
  const [confirmLocationAction, setConfirmLocationAction] = useState("");
  const notify = useNotify();

  useEffect(() => {
    debugger;
    if (!location) return;
    if (aisle.type === LocationType.BULK || isBulkLocation(location)) {
      getBulkData();
      setSelectedLocation({
        ...location,
        name: getLocationViewName(location),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  useEffect(() => {
    if (selectedAccountId) {
      getProducts(
        selectedLocation,
        selectedAccountId,
        setLoading,
        setProducts,
        notify,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedAccountId]);

  const handleCancel = () => {
    setBulkCapacityError(false);
    handleClose();
  };

  const getBulkData = async () => {
    debugger;
    if (!location) return;
    try {
      setLoading(true);
      const accounts = await getAccounts(setAccounts);
      if (location.productId?.trim()) {
        const response = await API.graphql(
          graphqlOperation(getLocationProduct, { id: location.productId }),
        );
        if (response.data.getProduct) {
          const locationProduct = response.data.getProduct;
          // setLocationProduct(locationProduct);
          const account = accounts.find(
            (itm) => itm.id === locationProduct.accountId,
          );
          if (account) setSelectedAccountId(account.id);
        } else {
          notify("Invalid product assigned to this location", "error");
        }
      } else if (location.accountName?.trim()) {
        const accountByName = accounts.find(
          (itm) => itm.businessName === location.accountName.trim(),
        );
        if (accountByName) setSelectedAccountId(accountByName.id);
      }
    } catch (err) {
      logError("Locations:StructuredLocationDialog:getBulkData", err, notify);
    } finally {
      setLoading(false);
    }
  };

  const renameLocation = (name) => {
    debugger;
    const maxLength = isBulkLocation(selectedLocation) ? 8 : 5;
    if (name.length > maxLength) {
      setLengthError(true);
    } else {
      setLengthError(false);
    }
    setSelectedLocation({ ...selectedLocation, name });
  };

  const handleBulkCapacityChange = (evt) => {
    setSelectedLocation({
      ...selectedLocation,
      bulkCapacity: evt.target.value,
    });
    validateBulkCapaicty(evt);
  };

  const handleProductChange = (productId) => {
    debugger;
    const product = products.find((itm) => itm.id === productId);
    const productName = product.name;
    const account = accounts.find((itm) => itm.id === selectedAccountId);
    const accountName = account.businessName;
    setSelectedLocation({
      ...selectedLocation,
      productId,
      productName,
      accountName,
      bulkUnits: product.defaultUOM,
    });
  };

  const isBulkCapacityRequired = () => {
    return selectedLocation.productId;
  };

  const isBulkCapacityValid = () => {
    if (isBulkCapacityRequired()) {
      return selectedLocation.bulkCapacity ? true : false;
    }
    return true;
  };

  const validateBulkCapaicty = (event) => {
    if (isBulkCapacityRequired() && !event.target.value) {
      setBulkCapacityError(true);
    } else {
      setBulkCapacityError(false);
    }
  };

  const handleLocationUpdate = async (newLocation) => {
    if (
      isBulkLocation(selectedLocation) &&
      selectedAccountId &&
      !selectedLocation.productId
    ) {
      return setAccountProductError(true);
    }
    debugger;
    const submitFlag = newLocation ? false : true;
    try {
      setLoading(true);
      if (!newLocation) newLocation = selectedLocation;
      if (isBulkLocation(newLocation)) {
        await handleUpdateBulkLocation(newLocation);
      } else {
        await handleUpdateNonBulkLocation();
      }
      refresh();
    } catch (err) {
      logError(
        "reloadYard:Location:StructuredLocationDialog:handleLocationUpdate",
        err,
        notify,
      );
    } finally {
      setLoading(false);
      if (submitFlag) handleClose();
    }
  };

  const handleUpdateBulkLocation = async (newLocation) => {
    debugger;
    if (newLocation.productId && newLocation.productId !== location.productId) {
      const account = accounts.find((itm) => itm.id === selectedAccountId);
      await createAggregateInventory(newLocation, account);
    }
    await doUpdateLocation(newLocation);
  };

  const handleUpdateNonBulkLocation = async () => {
    try {
      debugger;
      await doUpdateLocation(selectedLocation);
      if (!areLocationLoadsEqual(location, selectedLocation)) {
        mergeLocationLoads(aisle, selectedLocation);
        await updateSelectedAisle(aisle);
      }
      if (location.name !== selectedLocation.name) {
        await processInventoriesUpdate();
      }
    } catch (err) {
      logError(
        "reloadYard:Location:StructuredLocationDialog:handleUpdateNonBulkocation",
        err,
        notify,
      );
    } finally {
      setLoading(false);
    }
  };

  const processInventoriesUpdate = async () => {
    // handle structured LOCATION update
    const responseList = [];
    debugger;

    const statusQueries = [
      InventoryStatus.UNLOADED,
      InventoryStatus.REVIEW,
      InventoryStatus.STORED,
    ];

    if (selectedLocation.name)
      selectedLocation.name = selectedLocation.name.trim().toUpperCase();

    for (const queryStatus of statusQueries) {
      let nextToken = true;
      const searchQuery = {
        locationId: selectedLocation.id,
        status: { beginsWith: queryStatus },
        limit: 1000,
      };

      while (nextToken) {
        const input =
          nextToken === true ? searchQuery : { nextToken, ...searchQuery };
        let results = await API.graphql(
          graphqlOperation(inventoryItemByLocationByStatus, input),
        );
        const inventoryItems =
          results.data.inventoryItemByLocationByStatus.items;
        nextToken = results.data.inventoryItemByLocationByStatus.nextToken;

        const responses = await Promise.allSettled(
          inventoryItems.map((inventoryItem) => {
            return doUpdateInventoryItem(inventoryItem, selectedLocation);
          }),
        );
        responseList.push(...responses);
      }
    }

    const resError = responseList.find((item) => item.status === "rejected");
    if (resError) {
      logError(
        "reloadYard:Locations:StructuredLocationDialog:processInventoriesUpdate",
        resError,
        false,
      );
      throw resError;
    }
  };

  const doUpdateInventoryItem = (inventoryItem, selectedLocation) => {
    const toUpdateInventoryItem = {
      ...inventoryItem,
      locationFullName: getLocationFullName(selectedLocation),
    };

    delete toUpdateInventoryItem.area;
    delete toUpdateInventoryItem.createdAt;
    delete toUpdateInventoryItem.inventory;
    delete toUpdateInventoryItem.location;
    delete toUpdateInventoryItem.seals;
    delete toUpdateInventoryItem.updatedAt;
    delete toUpdateInventoryItem.zone;

    return API.graphql(
      graphqlOperation(updateInventoryItemMini, {
        input: toUpdateInventoryItem,
      }),
    );
  };

  const doUpdateLocation = async (selectedLocation) => {
    debugger;
    const toUpdateLocation = {
      ...selectedLocation,
      bulkCapacity: selectedLocation.bulkCapacity || null,
      name: null,
    };

    if (
      selectedLocation.name &&
      selectedLocation.name !== getLocationViewName(toUpdateLocation)
    ) {
      toUpdateLocation.name = selectedLocation.name.trim().toUpperCase();
    }

    delete toUpdateLocation.aisle;
    delete toUpdateLocation.area;
    delete toUpdateLocation.zone;
    delete toUpdateLocation.createdAt;
    delete toUpdateLocation.updatedAt;
    delete toUpdateLocation.length;
    delete toUpdateLocation.width;
    delete toUpdateLocation.accountName;
    delete toUpdateLocation.locationLoad;
    delete toUpdateLocation.tags;

    toUpdateLocation.productId = toUpdateLocation.productId || "";
    await API.graphql(
      graphqlOperation(updateLocation, { input: toUpdateLocation }),
    );
  };

  const handleLocationLoadType = (evt) => {
    const name = evt.target.name;

    if (
      name === LocationLoadType.CONTAINER ||
      name === LocationLoadType.OTHER
    ) {
      for (let key in selectedLocation.locationLoad)
        selectedLocation.locationLoad[key].selected = false;
    } else {
      selectedLocation.locationLoad[LocationLoadType.CONTAINER].selected =
        false;
      selectedLocation.locationLoad[LocationLoadType.OTHER].selected = false;
    }

    // Create a new locationLoad object
    const newLocationLoad = {
      ...selectedLocation.locationLoad,
      [name]: {
        ...selectedLocation.locationLoad[name],
        selected: evt.target.checked,
      },
    };
    // selectedLocation.locationLoad[evt.target.name].selected = evt.target.checked;

    const notSelected = Object.keys(newLocationLoad).reduce(
      (val, k) => val || newLocationLoad[k].selected,
      false,
    );
    if (!notSelected) newLocationLoad.other.selected = true;
    setSelectedLocation({
      ...selectedLocation,
      locationLoad: { ...newLocationLoad },
    });
  };

  const handleTypeCapacity = (value, typeName) => {
    selectedLocation.locationLoad[typeName].capacity = Number(value);
    setSelectedLocation({ ...selectedLocation });
  };

  const handleRemoveProduct = async () => {
    try {
      setConfirmLocationOpen(false);
      setLoading(true);
      debugger;
      const newLocation = {
        ...selectedLocation,
        productId: null,
        productName: " ",
        accountName: null,
      };
      if (location.productId) {
        await deAggregateInventory(selectedLocation);
      }
      await handleLocationUpdate(newLocation);
      setSelectedLocation(newLocation);
      setSelectedAccountId("");
    } catch (err) {
      logError(
        "reloadYard:Locations:StructuredLocationDialog:handleClearLocation",
        err,
        false,
      );
    } finally {
      setLoading(false);
    }
  };

  const handleClearLocationCapacity = async () => {
    debugger;
    setConfirmLocationOpen(false);
    await clearLocationCapacity();
  };

  const clearLocationCapacity = async () => {
    try {
      setLoading(true);
      // Nothing in the inventory flow clears isContaminated -- an emptied tank
      // still holds the residue -- so this is the one place a tank comes clean.
      // The manager clearing it stands for the tank having been washed out.
      const newLocation = {
        ...selectedLocation,
        capacityUsed: 0,
        capacityAllocated: 0,
        isContaminated: false,
      };
      await handleLocationUpdate(newLocation);
    } catch (err) {
      logError(
        "reloadYard:Locations:StructuredLocationDialog:handleClearLocation",
        err,
        false,
      );
    } finally {
      setLoading(false);
    }
  };

  const isLocationDisabled = () => {
    return (
      location?.productId ||
      (location?.capacityUsed || 0) + (location?.capacityAllocated || 0) > 0
    );
  };

  const handleOpenConfirmCapacity = () => {
    setConfirmLocationAction("ClearLocation");
    setConfirmLocationTitle("Clear Location Capacity");
    // On a contaminated tank the confirm has to say what else it does: the
    // manager is signing off on the tank having been cleaned, not just zeroing
    // a number, and clean stock becomes storable again the moment they do.
    setConfirmLocationContent(
      location?.isContaminated
        ? "Are you sure you want to reset this location capacity used to zero? This tank has held damaged stock -- clearing it marks the tank cleaned, and clean stock may be stored in it again."
        : "Are you sure you want to reset this location capacity used to zero?",
    );
    setConfirmLocationOpen(true);
  };

  const handleOpenConfirmRemoveProduct = () => {
    setConfirmLocationAction("RemoveProduct");
    setConfirmLocationTitle("Remove Product");
    setConfirmLocationContent(
      `Are you sure you want to remove ${selectedLocation.productName} from ${selectedLocation.name}?`,
    );
    setConfirmLocationOpen(true);
  };

  const handleConfirmAction = () => {
    if (confirmLocationAction === "ClearLocation") {
      handleClearLocationCapacity();
    } else if (confirmLocationAction === "RemoveProduct") {
      handleRemoveProduct();
    }
  };

  const isRemoveProductDisabled = () => {
    if (!selectedLocation.productId) return true;
    return (
      (location?.capacityUsed || 0) + (location?.capacityAllocated || 0) > 0
    );
  };

  const isClearCapacityDisabled = () => {
    // A contaminated tank stays clearable at zero capacity. Contamination
    // outlives the stock, so a tank emptied by shipping out would otherwise be
    // shut to clean stock with no way left to reopen it.
    if (location?.isContaminated) return false;
    return (
      (location?.capacityUsed || 0) + (location?.capacityAllocated || 0) === 0
    );
  };

  const isSubmitDisabled = () => {
    const disabled = loading || lengthError;
    return isBulkLocation(selectedLocation)
      ? disabled || !isBulkCapacityValid()
      : disabled;
  };

  const getAccountOptions = (allowEmpty = false) => {
    const options = accounts?.map((itm) => (
      <MenuItem key={itm.id} value={itm.id}>
        {itm.businessName}
      </MenuItem>
    ));
    if (allowEmpty) {
      options.unshift(
        <MenuItem key="" value="">
          &nbsp;
        </MenuItem>,
      );
    }

    return options;
  };

  const handleAccountChange = (accountId) => {
    setSelectedAccountId(accountId);
    if (!accountId) {
      setSelectedLocation({ ...selectedLocation, productId: "" });
    }
  };
  const capacityPercent = trimDecimal(
    (selectedLocation.capacityUsed / selectedLocation?.bulkCapacity) * 100,
  );

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md">
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <DialogTitle id="edit-location">Edit Location</DialogTitle>
      <DialogContent>
        <Grid container spacing={1}>
          <Grid item xs={6} md={4}>
            <TextField
              id="name"
              label="Name"
              size="small"
              variant="outlined"
              value={selectedLocation.name}
              required
              fullWidth
              error={lengthError}
              helperText={lengthError && "Max length is 5 characters."}
              onChange={(evt) => renameLocation(evt.target.value)}
              inputProps={{ style: { textTransform: "uppercase" } }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    {getLocationPrefix(aisle)}
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={6} md={4}>
            <TextField
              id="capacity-used"
              label="Capacity Used"
              size="small"
              variant="outlined"
              fullWidth
              disabled
              type="number"
              value={capacityPercent || "0"}
              className={classes.locationEditInput}
              InputProps={{
                endAdornment: <InputAdornment position="end">%</InputAdornment>,
              }}
            />
          </Grid>

          {isBulkLocation(selectedLocation) && (
            <Grid item container spacing={1}>
              <Grid item xs={6} md={4}>
                <TextField
                  select
                  name="account"
                  label="Account"
                  size="small"
                  variant="outlined"
                  fullWidth
                  onChange={(evt) => handleAccountChange(evt.target.value)}
                  disabled={isLocationDisabled()}
                  value={selectedAccountId || ""}
                >
                  {getAccountOptions(true)}
                </TextField>
              </Grid>
              <Grid item xs={6} md={4}>
                <TextField
                  name="product"
                  label="Product"
                  size="small"
                  variant="outlined"
                  fullWidth
                  onChange={(evt) => handleProductChange(evt.target.value)}
                  disabled={!selectedAccountId || isLocationDisabled()}
                  select
                  value={selectedLocation.productId || ""}
                  error={accountProductError}
                  helperText={
                    accountProductError ? "Please select a Product" : ""
                  }
                >
                  {products?.map((itm) => (
                    <MenuItem key={itm.id} value={itm.id}>
                      {itm.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={6} md={4}>
                <Button
                  size="large"
                  type="submit"
                  startIcon={<RemoveIcon />}
                  onClick={handleOpenConfirmRemoveProduct}
                  disabled={isRemoveProductDisabled()}
                >
                  Remove Product
                </Button>
              </Grid>
              <Grid item xs={6} md={4}>
                <TextField
                  type="number"
                  id="bulk-capacity"
                  label="Capacity"
                  size="small"
                  variant="outlined"
                  fullWidth
                  error={bulkCapacityError}
                  helperText={bulkCapacityError && "Required"}
                  disabled={
                    location?.capacityUsed || location?.capacityAllocated
                  }
                  required={isBulkCapacityRequired()}
                  value={selectedLocation.bulkCapacity}
                  inputProps={{ min: 0 }}
                  onChange={handleBulkCapacityChange}
                  onKeyDown={handleNumberFieldKeyDown}
                  onBlur={validateBulkCapaicty}
                />
              </Grid>
              <Grid item xs={6} md={4}>
                <TextField
                  select
                  name="uom"
                  label="UOM"
                  size="small"
                  variant="outlined"
                  fullWidth
                  disabled
                  required={selectedLocation.productId ? true : false}
                  value={selectedLocation.bulkUnits}
                >
                  {getBulkUnitOptions(true)}
                </TextField>
              </Grid>
              <Grid item xs={6} md={4}></Grid>
              {isRemoveProductDisabled && (
                <>
                  <Grid item xs={6} md={4}>
                    <TextField
                      name="capacity-used"
                      label="Capacity used"
                      size="small"
                      variant="outlined"
                      fullWidth
                      disabled
                      value={location?.capacityUsed || 0}
                    />
                  </Grid>
                  <Grid item xs={6} md={4}>
                    <TextField
                      name="capacity-allocated"
                      label="Capacity allocated"
                      size="small"
                      variant="outlined"
                      fullWidth
                      disabled
                      value={location?.capacityAllocated || 0}
                    />
                  </Grid>
                  <Grid item xs={6} md={4}>
                    <Button
                      size="large"
                      type="submit"
                      startIcon={<ClearIcon />}
                      onClick={handleOpenConfirmCapacity}
                      disabled={isClearCapacityDisabled()}
                    >
                      Clear capacity
                    </Button>
                  </Grid>
                </>
              )}
            </Grid>
          )}

          {selectedLocation?.type && !isBulkLocation(selectedLocation) && (
            <>
              <Grid item xs={12}>
                <Box mt={1}>
                  <FormLabel component="legend">Load Type</FormLabel>
                </Box>
              </Grid>
              <Grid item xs={6} sm={2}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedLocation.locationLoad.pallet?.selected}
                      onChange={handleLocationLoadType}
                      name={LocationLoadType.PALLET}
                      disabled={isLoadTypeDisabled(
                        selectedLocation,
                        LocationLoadType.PALLET,
                      )}
                    />
                  }
                  label="Pallet"
                />
              </Grid>
              <Grid item xs={6} sm={2}>
                <TextField
                  name="typeCapacity"
                  size="small"
                  variant="outlined"
                  disabled={isLoadTypeDisabled(
                    selectedLocation,
                    LocationLoadType.PALLET,
                  )}
                  onChange={(evt) =>
                    handleTypeCapacity(
                      evt.target.value,
                      LocationLoadType.PALLET,
                    )
                  }
                  select
                  value={selectedLocation.locationLoad.pallet.capacity}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">%</InputAdornment>
                    ),
                  }}
                >
                  {capacityList.map((itm) => (
                    <MenuItem key={itm} value={itm}>
                      {itm}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={6} sm={2}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedLocation.locationLoad.box?.selected}
                      onChange={handleLocationLoadType}
                      name={LocationLoadType.BOX}
                      disabled={isLoadTypeDisabled(
                        selectedLocation,
                        LocationLoadType.BOX,
                      )}
                    />
                  }
                  label="Box"
                />
              </Grid>
              <Grid item xs={6} sm={2}>
                <TextField
                  name="typeCapacity"
                  size="small"
                  variant="outlined"
                  onChange={(evt) =>
                    handleTypeCapacity(evt.target.value, LocationLoadType.BOX)
                  }
                  select
                  value={selectedLocation.locationLoad.box.capacity}
                  disabled={isLoadTypeDisabled(
                    selectedLocation,
                    LocationLoadType.BOX,
                  )}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">%</InputAdornment>
                    ),
                  }}
                >
                  {capacityList.map((itm) => (
                    <MenuItem key={itm} value={itm}>
                      {itm}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={6} sm={2}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={
                        selectedLocation.locationLoad.superSack?.selected
                      }
                      onChange={handleLocationLoadType}
                      name={LocationLoadType.SUPERSACK}
                      disabled={isLoadTypeDisabled(
                        selectedLocation,
                        LocationLoadType.SUPERSACK,
                      )}
                    />
                  }
                  label="Super Sack"
                />
              </Grid>
              <Grid item xs={6} sm={2}>
                <TextField
                  name="typeCapacity"
                  size="small"
                  variant="outlined"
                  onChange={(evt) =>
                    handleTypeCapacity(
                      evt.target.value,
                      LocationLoadType.SUPERSACK,
                    )
                  }
                  select
                  value={selectedLocation.locationLoad.superSack.capacity}
                  disabled={isLoadTypeDisabled(
                    selectedLocation,
                    LocationLoadType.SUPERSACK,
                  )}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">%</InputAdornment>
                    ),
                  }}
                >
                  {capacityList.map((itm) => (
                    <MenuItem key={itm} value={itm}>
                      {itm}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={6} sm={4}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedLocation.locationLoad.dryBulk?.selected}
                      onChange={handleLocationLoadType}
                      name={LocationLoadType.DRY_BULK}
                      disabled={isLoadTypeDisabled(
                        selectedLocation,
                        LocationLoadType.DRY_BULK,
                      )}
                    />
                  }
                  label="Dry Bulk"
                />
              </Grid>
              <Grid item xs={6} sm={4}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={
                        selectedLocation.locationLoad.liquidBulk?.selected
                      }
                      onChange={handleLocationLoadType}
                      name={LocationLoadType.LIQUID_BULK}
                      disabled={isLoadTypeDisabled(
                        selectedLocation,
                        LocationLoadType.LIQUID_BULK,
                      )}
                    />
                  }
                  label="Liquid Bulk"
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={
                        selectedLocation.locationLoad.container?.selected
                      }
                      name={LocationLoadType.CONTAINER}
                      disabled
                    />
                  }
                  label="Container"
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <FormControlLabel
                  label="Other"
                  control={
                    <Checkbox
                      checked={selectedLocation.locationLoad.other?.selected}
                      onChange={handleLocationLoadType}
                      name={LocationLoadType.OTHER}
                      disabled={isLoadTypeDisabled(
                        selectedLocation,
                        LocationLoadType.OTHER,
                      )}
                    />
                  }
                />
              </Grid>
            </>
          )}
        </Grid>
        <Confirm
          isOpen={confirmLocationOpen}
          loading={loading}
          title={confirmLocationTitle}
          content={confirmLocationContent}
          onConfirm={handleConfirmAction}
          onClose={() => setConfirmLocationOpen(false)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={() => handleLocationUpdate()}
          color="primary"
          disabled={isSubmitDisabled()}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};
